<template>
  <div class="proa-input-group">
    <label v-if="label" class="input-label">
      <span>{{ label }}</span>
      <span v-if="labelWithRequired" class="text-service">（必須）</span>
    </label>
    <slot name="input"></slot>
    <label v-if="invalidFeedback" class="invalid-feedback-label">{{ invalidFeedback }}</label>
  </div>
</template>

<script>
export default {
  name: 'ProaInputGroup',
  props: {
    label: {
      type: String,
      default: ''
    },
    labelWithRequired: Boolean,
    invalidFeedback: {
      type: String,
      default: ''
    }
  }
}
</script>

<style scoped lang="scss">
@import "@/styles/variables";

.proa-input-group {
  margin-bottom: 20px;

  .input-label {
    display: block;
    font-size: 14px;
    font-weight: 600;
    color: $secondary-color;
  }

  .invalid-feedback-label {
    margin-top: 20px;
    color: $error-color;
  }
}
</style>
